/** The currencies a document can quote a second, indicative amount in.
 *
 * The set the euro reference rates cover, and nothing else: a currency outside it has no rate to
 * quote, so offering it would be offering a choice the server then refuses. Codes only -- the name
 * beside each is asked of the browser in whatever language the app is running in
 * (`Intl.DisplayNames`), the same way the country list is built.
 *
 * The published set does move -- a currency joining the euro leaves it. One that has left is
 * refused by the server when the document is saved, naming itself, rather than printing a rate
 * nobody published.
 */
export const INDICATIVE_CURRENCY_CODES: readonly string[] = [
	'AUD', 'BRL', 'CAD', 'CHF', 'CNY', 'CZK', 'DKK', 'GBP', 'HKD', 'HUF', 'IDR', 'ILS', 'INR', 'ISK', 'JPY',
	'KRW', 'MXN', 'MYR', 'NOK', 'NZD', 'PHP', 'PLN', 'RON', 'SEK', 'SGD', 'THB', 'TRY', 'USD', 'ZAR',
];

/** The codes, named in `language`, sorted by that name -- the order a reader expects to scan. */
export function indicativeCurrencyOptions(language: string): { code: string; label: string }[] {
	const names = new Intl.DisplayNames([language], { type: 'currency' });
	return INDICATIVE_CURRENCY_CODES.map((code) => ({ code, label: names.of(code) ?? code })).sort((a, b) => a.label.localeCompare(b.label, language));
}
